module.exports = __webpack_public_path__ + "img/silo.3a2b7db1.gif";